import { render, staticRenderFns } from "./ProviderConnectionForm.vue?vue&type=template&id=f484d5a8&scoped=true&"
import script from "./ProviderConnectionForm.vue?vue&type=script&lang=ts&"
export * from "./ProviderConnectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderConnectionForm.vue?vue&type=style&index=0&id=f484d5a8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f484d5a8",
  null
  
)

export default component.exports